<template>
  <div class="form">
    <p class="form__title">{{ t('forms.signIn') }}</p>
    <div class="form__inputs">
      <ui-input
        :type="'email'"
        :placeholder="t('fields.email')"
        :rules="[isEmail]"
        v-model="email"
      />
      <ui-input
        :type="'password'"
        :placeholder="t('fields.password')"
        :rules="[required]"
        v-model="password"
      />
    </div>
    <p @click="appStore.setActiveState('forgot')" class="form__forgot">{{ t('forms.forgotText') }}</p>
    <ui-button
      :isDisabled="!isFormValid"
      :isLoading="isLoading"
      @click="login"
    >
      {{ t('buttons.login') }}
    </ui-button>
    <p class="form__register">
      {{ t('forms.noAcc') }}
      <span @click="appStore.setActiveState('signUp')">{{ t('buttons.signUp') }}</span>
    </p>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiInput from "@/components/ui/ui-input.vue";
import {isEmail, required} from "@/core/rules/textFieldRules.js";
import {computed, ref} from "vue";
import {useAppStore} from "@/stores/app.js";
import UiButton from "@/components/ui/ui-button.vue";
import {ElNotification} from "element-plus";
import {useAuthStore} from "@/stores/auth.js";
import {Auth} from "@/core/api/auth.js";
import {useRouter} from "vue-router";
import {Orders} from "@/core/api/orders.js";
import {useCartStore} from "@/stores/cart.js";

const {t} = useI18n()
const appStore = useAppStore()
const authStore = useAuthStore()
const cartStore = useCartStore()
const router = useRouter()

const email = ref('')
const password = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true &&
    required(password.value) === true
  )
})

const login = async () => {
  isLoading.value = true

  const res = await Auth.login(email.value, password.value)

  if (!res.errors) {
    authStore.setUser({
      user: res.data.obtainJwtToken.user,
      accessToken: res.data.obtainJwtToken.accessToken
    })

    // if (res.data.obtainJwtToken.user.language !== translation.currentLocale) {
    //   translations.switchLanguage(res.data.obtainJwtToken.user.language)
    // }

    await router.push({
      name: 'home',
      params: {
        locale: localStorage.getItem('gce-user-locale') || 'en-gb'
      }
    })

    localStorage.setItem('gce-refresh', res.data.obtainJwtToken.refreshToken)

    const currentOrder = await Orders.getOrders("PENDING", res.data.obtainJwtToken.accessToken, res.data.obtainJwtToken.user.email)
    cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)
  } else {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }

  appStore.setActiveState('')
  isLoading.value = false
}
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  &__title {
    font-family: Poppins, sans-serif;
    font-size: 30px;
    font-weight: 600;
    color: $main;
  }

  &__inputs {
    width: 100%;
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }

  &__forgot {
    margin-block: 10px;
    cursor: pointer;
    transition: 0.2s;
    align-self: flex-end;
    color: #7c8ba0;
    font-family: Poppins, sans-serif;
    font-size: 12px;

    @include hover {
      color: #616e81;
    }
  }

  &__register {
    align-self: flex-start;
    font-family: Poppins,sans-serif;
    font-size: 14px;
    margin-top: 10px;

    & span {
      cursor: pointer;
      transition: 0.2s;
      color: $main;

      @include hover {
        color: $mainHover;
      }
    }
  }
}
</style>